import React from 'react'
import LoginForm from './LoginForm'
import SLogo from '../../../img/logos/white_logo.png'
import { ToastContainer, ToastMessage } from 'react-toastr'
import { loginUser, getToken } from '../../Commons/Authentication'
import { hashHistory } from 'react-router'
import * as request from 'superagent'
import NoCache from 'superagent-no-cache'

const ToastMessageFactory = React.createFactory(ToastMessage.animation)

export default class LoginComponent extends React.Component {
  componentWillMount () {
    this.loadUserData()
  }

  loadUserData () {
    let endpoint = 'api/v1/user/find'
    request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) console.log('nologueado', err)
        else {
          hashHistory.push('search')
          // if (res.body.nombrecompleto !== '' && res.body.nombrecompleto !== undefined) {
          //   this.setState({user: res.body.nombrecompleto, rol: res.body.rol[0].nombre, rolLabel: res.body.rol[0].label})
          // } else {
          //   this.setState({user: res.body.email, rol: res.body.rol[0].nombre, rolLabel: res.body.rol[0].label})
          // }
        }
      })
  }
  login (email, password) {
    if (email === '' || password === '') {
      this.refs.container.error('Ingrese email y contraseña', 'No puede iniciar sesión', {
        closeButton: true
      })
    } else {
      request
        .post('api/v1/user/login')
        .send({ user: { email: email, password: password } })
        .set('Accept', 'application/json')
        .end((err, res) => {
          if (err || !res.body.token) {
            this.refs.container.error('Email o contraseña incorrectos', 'No puede iniciar sesión', {
              closeButton: true
            })
          } else {
            loginUser(res.body.token)
            this.refs.container.info('Bienvenido ' + email, '', {
              closeButton: true
            })
            setTimeout(() => { hashHistory.push('search') }, 2000)
          }
        })
    }
  }

  render () {
    document.title = 'Iniciar Sesión - CORE 3.0'
    return (
      <div className='form-page-container'>
        <ToastContainer toastMessageFactory={ToastMessageFactory} ref='container' className='toast-top-right' />
        <div className='form-field-container-image'>
          <img src={SLogo} />
        </div>
        <LoginForm login={this.login.bind(this)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Account/Login/LoginComponent.js